/**
 * Error and warning logging
 */

export const logger = {
  error(error: unknown, context?: Record<string, unknown>) {
    console.error('Channel Error:', {
      error,
      context,
      timestamp: new Date().toISOString(),
      // Add any other relevant info
    });
  },
  
  warn(message: string, details?: Record<string, unknown>) {
    console.warn('Channel Warning:', {
      message,
      details,
      timestamp: new Date().toISOString()
    });
  },

  info(message: string, details?: Record<string, unknown>) {
    console.info('Channel Info:', {
      message,
      details,
      timestamp: new Date().toISOString()
    });
  }
}; 